<div class="card">
    <div class="free-badge" *ngIf="!ondemand.abbonamento">            
        <i class="bi bi-unlock-fill"></i>
    </div>
    <div class="card-content" [style.background-image]="backgroundImage | async">      
        <div class="card-loader" *ngIf="!(imageLoaded | async)" [@fadeInOut]>
            <div class="ring-spinner"></div>
        </div>    
    </div>
    <div class="card-content-gif">
        <div class="gif" [style.background-image]="backgroundGif | async">
            <div class="card-loader" *ngIf="!(gifLoaded | async)" [@fadeInOut]>
                <div class="ring-spinner"></div>
            </div>    
        </div>
        <div class="p-4 flex flex-row gap-2 items-center bg-header-color">        
            <div class="flex flex-col gap-2 w-3/4">
                <p class="text-white font-bold text-sm">{{ondemand.titolo.length > 60 ? ondemand.titolo.slice(0, 60) + '...' : ondemand.titolo}}
                    <span class="font-normal"><br>{{getTime(ondemand.durata)}}</span>
                </p>
            </div>
            <div class="w-1/4 flex justify-center">
                <div class="play rounded-full border-white border hover:bg-gray-400/50 aspect-square cursor-pointer">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.6667 6.6548C10.6667 6.10764 11.2894 5.79346 11.7295 6.11862L24.377 15.4634C24.7377 15.7298 24.7377 16.2692 24.3771 16.5357L11.7295 25.8813C11.2895 26.2065 10.6667 25.8923 10.6667 25.3451L10.6667 6.6548Z" fill="currentColor" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</div>